// extracted by mini-css-extract-plugin
export var typingIndicator = "_mr-0";